// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b4a9ef2","239":"0c766787","453":"b808e5ce","455":"02625bef"}[chunkId] + ".chunk.js";
};